import { areAllHomePageDevicesLoaded } from "../devices/devices.selectors";
import { getRemoteReminderDialogVisibilityStatus } from "./reminder.selectors";
import { openReminderDialog } from "../../components/spsonReminderDialog/SpsonReminderDialog";
import { isSPSONAvailable } from "../account";

export const SHOW_REMOTE_REMINDER_DIALOG =
  "[REMINDER] SHOW_REMOTE_REMINDER_DIALOG";
export const showRemoteReminderDialog = () => ({
  type: SHOW_REMOTE_REMINDER_DIALOG,
});

export const HIDE_REMOTE_REMINDER_DIALOG =
  "[REMINDER] HIDE_REMOTE_REMINDER_DIALOG";
export const hideRemoteReminderDialog = () => ({
  type: HIDE_REMOTE_REMINDER_DIALOG,
});

export const checkLoadingStateAndShowRemoteDialog =
  () => (dispatch, getState) => {
    const state = getState();
    const isRemoteEnabled = isSPSONAvailable(state);
    const showDialog = getRemoteReminderDialogVisibilityStatus(state);
    const isLoadingFinished = areAllHomePageDevicesLoaded(state);

    if (isRemoteEnabled && isLoadingFinished && showDialog) {
      dispatch(openReminderDialog());
    }
  };
